import { push } from 'connected-react-router'

import reserveApi from '../utils/axios'
import store from '../store'

export function fetchFacility(value) {
  const facilities = store.getState().facilities.facilities

  return dispatch => {
    dispatch({ type: 'FETCH_FACILITY' })
    const facility = facilities.find(facility => facility.id === value || facility.slug === value)

    if (facility) {
      dispatch({ type: 'FETCH_FACILITY_FULFILLED', payload: facility })
    } else {
      return reserveApi({
        method: 'get',
        url: `/facilities/${value}.json`
      })
        .then(response => {
          dispatch({
            type: 'FETCH_FACILITY_FULFILLED',
            payload: response.data
          })
          return Promise.resolve
        })
        .catch(err => {
          dispatch({ type: 'FETCH_FACILITY_REJECTED', payload: err })
        })
    }
  }
}

export function updateFacility(id, apiValues) {
  return function (dispatch) {
    dispatch({ type: 'UPDATE_FACILITY' })
    return reserveApi({
      method: 'put',
      url: `/admin/facilities/${id}.json`,
      data: { facility: apiValues }
    })
      .then(response => {
        if (apiValues.ooo !== undefined) {
          dispatch({ type: 'FETCH_FACILITY_FULFILLED', payload: response.data })
        }
      })
      .catch(err => {
        dispatch({ type: 'FETCH_FACILITY_REJECTED', payload: err })
      })
  }
}

export function fetchFacilities(value) {
  const filters = store.getState().facilities.filter

  return dispatch => {
    dispatch({ type: 'FACILITIES_QUERY', payload: value })
    dispatch({ type: 'FETCH_FACILITIES' })
    return reserveApi({
      method: 'get',
      url: '/facilities.json',
      params: { q: value, agencyId: filters.agency?.id, facilityGroupId: filters.facilityGroup?.id }
    })
      .then(response => {
        dispatch({
          type: 'FETCH_FACILITIES_FULFILLED',
          payload: response.data
        })
      })
      .catch(err => {
        dispatch({ type: 'FETCH_FACILITIES_REJECTED', payload: err })
      })
  }
}

export function fetchGroupedAvailabilities(facility_id) {
  return dispatch => {
    dispatch({ type: 'FETCH_GROUP_AVAILS' })
    return reserveApi({
      method: 'get',
      url: `/facilities/${facility_id}/availabilities.json`
    })
      .then(response => {
        dispatch({
          type: 'FETCH_GROUP_AVAILS_FULFILLED',
          payload: response.data
        })
      })
      .catch(err => {
        dispatch({ type: 'FETCH_GROUP_AVAILS_REJECTED', payload: err })
      })
  }
}

export function groupedAvailabilitiesFilterSiteType(value) {
  return dispatch => dispatch({ type: 'GROUP_AVAILS_FILTER_SITE_TYPE', payload: value })
}

export function groupedAvailabilitiesSort(value) {
  return dispatch => dispatch({ type: 'GROUP_AVAILS_SORT', payload: value })
}

export function facilityFilterAgency(agency) {
  return dispatch => {
    dispatch({ type: 'SET_FACILITY_FILTER', payload: { agency } })
    dispatch(fetchFacilities())
  }
}

export function facilityFilterFacilityGroup(facilityGroup) {
  return dispatch => {
    dispatch({ type: 'SET_FACILITY_FILTER', payload: { facilityGroup } })
    dispatch(fetchFacilities())
  }
}

export function facilityNewRequest(facility) {
  return dispatch => {
    dispatch(push(`/new/${facility.slug}`))
  }
}

export function fetchFacilitiesNearby(facilityId) {
  return dispatch => {
    dispatch({ type: 'FETCH_NEARBY_FACILITIES', payload: facilityId })
    return reserveApi({
      method: 'get',
      url: `/facilities/${facilityId}/nearby.json`
    })
      .then(response => {
        dispatch({
          type: 'FETCH_NEARBY_FACILITIES_FULFILLED',
          payload: response.data
        })
      })
      .catch(err => {
        dispatch({ type: 'FETCH_NEARBY_FACILITIES_REJECTED', payload: err })
      })

  }
}
